export const Messages = {
  ADD_SUCCESS: "{item} was saved successfully",
  ADD_SUCCESS_APPLICATION: "{item} was submitted successfully",
  ADD_SUCCESS_ACCOUNT: "{item} created successfully. An email has been sent to your email address, please check your inbox/spam folder for further instructions",
  ADD_FAILURE: "Oops system failed to save {item}, please try again later",
  ADD_SUCCESS_DOC: "{item} were saved successfully",
  ADD_FAILURE_DOC: "Oops system failed to save {item}, please try again later",
  GET_SUCCESS: "{item} was retrieved successfully",
  GET_FAILURE: "Oops system failed to retrieve {item}, please try again",
  UPDATE_SUCCESS: "{item} was updated successfully",
  UPDATE_SUCCESSWITHOK:
    "{item} was updated successfully" +
    "\n" +
    "but your changes will only take effect on your next login",
  UPDATE_FAILURE: "Oops system failed to update {item}, please try again",
  UPDATE_CANCELLED: "",
  EXIST_UPDATE_FAILURE:
    "Oops system failed to update {item}, record already exist",
  EXIST_ADD_FAILURE: "Oops system failed to add {item}, record already exist",
  USER_REQUEST_FAILURE: "Something is incorrect with front-end input",
  SERVER_REQUEST_FAILURE: "Server failed to process your request, please try again later",
  USER_EXISTS: "Provided email is already in use",
  EMAIL_SEND_SUCCESS: "Email was sent successfully to {item}",
  EMAIL_SEND_FAILURE: "Oops! system failed to send email to {item}",
  INVALID_EMAIL_DOMAIN: "Email syntax or domain is invalid",
  INVALID_TOKEN_EXPIRES: "Unauthorised, invalid or expired token",
  UNAUTHORISED: "Unauthorised access, due to user rights",
  AGE_LIMIT_EXCEEDED:
    "Your age is above the NYS programme age limit of 35, you're not eligible to apply",
  UPDATE: "{item} withdrawal was successfully",
  UPDATE_FAILURE: "Oops system failed to update {item}, please try again later",
  FILE_UPLOAD_NO_FILE: "No file(s) to upload",
  CLOSING_DATE: "System failed to retrieve closing date",
  SUCCESS: "{item} was successful",
  FAILURE: "Oops {item} failed, please try again later",
  PUBLIC_USER_EXISTS: "Provided email is already in use, please reset your password to proceed",
  DATE_ERROR: "{item}  Please enter correct date",

  JOIN_SUCCESS: "Thank you for submitting your details. Please check your email for a confirmation message",
  JOIN_FAILURE: "Oops system failed to submit {item}, please try again later",
  INVALID_CAPTCHA: "Captcha provided is invalid, please try again",
  CLOSE_SUCCESS: "{item} was closed successfully",
};

export const Notify = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
  DESTROY: "destroy",
});
